import NewsletterSection from "../../../../src/components/whitepaper/NewsletterSection";
import * as React from 'react';
export default {
  NewsletterSection,
  React
};